const map = {
  namespaced: true,
  state: () => ({
    city: null,
    models: [],
  }),
  mutations: {
    setCity(state, city) {
      state.city = city;
    },
    setModels(state, models) {
      state.models = models;
    },
    addModel(state, model) {
      state.models.push(model);
      state.models = [...new Set(state.models)];
    },
    removeModel(state, model) {
      state.models = state.models.filter(m => m !== model);
    }
  },
  actions: {
    setCity({commit}, city) {
      commit('setCity', city);
    },
    addModel({commit}, model) {
      commit('addModel', model);
    },
    removeModel({commit}, model) {
      commit('removeModel', model);
    },
    setModels({commit}, models) {
      commit('setModels', models);
    },
  },
  getters: {
    getCity(state) {
      return state.city;
    },
    getModels(state) {
      return state.models;
    }
  }
}

export default map